import ServiqLogo from './SarviqLogo';

export default ServiqLogo;
